import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ServiceFee.css';
import cx from 'classnames';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import Loader from '../../../components/Common/Loader/Loader';
import getServiceFee from './getServiceFee.graphql';
import ManageServiceFee from '../../../components/SiteAdmin/ManageServiceFee/ManageServiceFee';
//meassage
import { FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';
import { Col, Row } from 'react-bootstrap';
import Link from '../../../components/Link/Link';
import getLocations from '../../../components/Shop/SignupForm/getLocations.graphql';


class ServiceFee extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    getServiceFee: PropTypes.shape({
      getServiceFee: PropTypes.array
    })
  };

  static defaultProps = {
    getServiceFee: {
      loading: false
    }
  }



  constructor(props) {
    super(props);
    this.state = {
      selectedLocation: 1,
      currentData: null,
      formKey: 1
    };
  }

  handleLocationChange(e) {
    const newLocation = parseInt(e.target.value, 10);
    this.setState({ selectedLocation: newLocation }, () => {
      // Refetch data when location changes
      this.props.serviceFee.refetch({
        locationId: newLocation
      }).then(({ data }) => {
        if (data && data.getServiceFee) {
          // Force a complete re-render with new data
          this.setState({
            currentData: null // Clear current data first
          }, () => {
            this.setState({
              currentData: data.getServiceFee,
              formKey: this.state.formKey + 1
            });
          });
        }
      });
    });
  }

  componentDidMount() {
    const { serviceFee } = this.props;
    if (serviceFee && serviceFee.getServiceFee) {
      this.setState({ currentData: serviceFee.getServiceFee });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { serviceFee } = nextProps;
    if (serviceFee && serviceFee.getServiceFee && serviceFee.getServiceFee !== this.props.serviceFee.getServiceFee) {
      // Force a complete re-render with new data
      this.setState({
        currentData: null // Clear current data first
      }, () => {
        this.setState({
          currentData: serviceFee.getServiceFee,
          formKey: this.state.formKey + 1
        });
      });
    }
  }


  render() {
    const { title, serviceFee, serviceFee: { loading }, getLocations } = this.props;
    const { currentData, formKey } = this.state;


    return (
      <Loader type={"page"} show={loading}>
        <div className={s.root}>
          <div className={s.container}>
            <div className={cx(s.heading)}>
              <FormattedMessage {...messages.manageServiceHeading} />
            </div>
            <div className='container'>
              <Row>
                <Col xl={11} lg={11} md={11} sm={10} xs={9} className='mx-auto p-4 mt-4 bg-light rounded border'>
                  <div className='form-group'>
                    <div className='d-flex justify-content-between mb-2'>
                      <label fpr='selectLocationForPricing'>
                        Location {' '}
                      </label>
                      {/* <Link to='/siteadmin/location/'>Manage Location</Link> */}
                    </div>

                    <select
                      className='form-control'
                      id='selectLocationForPricing'
                      value={this.state.selectedLocation}
                      onChange={e => this.handleLocationChange(e)}
                    >
                      {getLocations && getLocations.getLocations && getLocations.getLocations.map(location => (
                        <option key={location.id} value={location.id}>
                          {location.locationName}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
              </Row>
              {currentData && (
                <ManageServiceFee
                  key={`${this.state.selectedLocation}-${formKey}`}
                  initialValues={currentData}
                />
              )}
            </div>
          </div>
        </div>
      </Loader>
    )
  }
}

export default compose(
  withStyles(s),
  graphql(getServiceFee, {
    name: 'serviceFee',
    options: (ownProps) => ({
      ssr: true,
      fetchPolicy: 'network-only',
      variables: {
        locationId: ownProps.selectedLocation || 1
      },
      notifyOnNetworkStatusChange: true,
    }),
  }),

  graphql(getLocations, {
    name: 'getLocations',
    options: {
      ssr: true,
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
    },
  })
)(ServiceFee);
